import React, { Component } from 'react';
import { withRouter} from 'react-router-dom';
import Cookies from 'js-cookie';
import * as appConstantsLocal from '../environments/appConstantsLocal.json';
import * as appConstantsStage from '../environments/appConstantsStage.json';
import * as appConstantsDev from '../environments/appConstantsDev.json';
import * as appConstantsProd from '../environments/appConstantsProd.json';


class SignOut extends Component{

    componentDidMount() {

        let hostname = window.location.hostname;

        if (hostname === 'uat.esri.com' || hostname.includes('preview')) {
            this.appConstantsData = appConstantsStage.default;
        } else if (hostname === 'aem-dev.esri.com') {
            this.appConstantsData = appConstantsDev.default;
        } else if (hostname.includes('localhost')) {
            this.appConstantsData = appConstantsLocal.default;
        } else {
            this.appConstantsData = appConstantsProd.default;
        }

        let searchParams = new URLSearchParams(this.props.location.search);
        let redirectURL = searchParams.get('redirect_uri');
        let domain = hostname.substring(hostname.indexOf("."));
        this.signOutUser(redirectURL,domain);
        
    }

    signOutUser(redirectURL, domain){
        let esriAuthCookie = Cookies.get('esri_auth');
        let signOutURL = this.appConstantsData.manageAccountUrl + '#redirect_uri=' + redirectURL + '&client_id=' + this.appConstantsData.clientId + '&signout=true';
        if(esriAuthCookie){
            Cookies.remove('esri_auth', {domain:domain});
        }
        window.location.href = signOutURL;
        

    }

    render() { 
        return (

            <div></div>
                
        );
    }   

}

export default withRouter(SignOut);